import { render, staticRenderFns } from "./ProjectSelect.vue?vue&type=template&id=45a58d96&"
import script from "./ProjectSelect.vue?vue&type=script&lang=js&"
export * from "./ProjectSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSelect.vue?vue&type=style&index=0&id=45a58d96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports